import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { StringFormatter } from '@repo/toolkit/string'
import { format } from 'date-fns'
import React from 'react'

import useTranslate from '../../../../../../apps/backoffice/src/lib/hooks/use-translate'
import { ChevronLeftIcon, ChevronRightIcon } from '../../../../icons'
import Typography from '../../../atoms/typography'

type Props = {
  currentDate: Date
  headerActions?: React.ReactNode
  prevMonth: () => void
  nextMonth: () => void
}

const FullCalendarHeader: React.FC<Props> = ({
  currentDate,
  headerActions,
  nextMonth,
  prevMonth
}) => {
  const { getLocale } = useTranslate()

  return (
    <div className="flex justify-between border-b border-grey-light p-4">
      <div className="flex items-center justify-between w-60">
        <div className="cursor-pointer border border-grey-light rounded p-1">
          <ChevronLeftIcon color={tailwindColors.grey.DEFAULT} onClick={prevMonth} />
        </div>
        <Typography variant="sub-heading" className="text-grey">
          {StringFormatter.capitalize(format(currentDate, 'MMMM yyyy', { locale: getLocale() }))}
        </Typography>
        <div className="cursor-pointer border border-grey-light rounded p-1">
          <ChevronRightIcon color={tailwindColors.grey.DEFAULT} onClick={nextMonth} />
        </div>
      </div>

      {headerActions && <div className="flex items-center gap-2">{headerActions}</div>}
    </div>
  )
}

export default FullCalendarHeader
